<template>
  <div class="SendMessage">
    <box :title="$t('nav-send-message')">
      <v-form v-model="form">
        <div class="pa-3">
          <table>
            <tbody>
              <tr>
                <td>{{ $t("messageTitle") }}:</td>
                <td>
                  <v-text-field
                    :rules="[$rules.required]"
                    solo
                    hide-details=""
                    :placeholder="$t('messageTitle')"
                    v-model="message.title"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>{{ $t("messageBody") }}:</td>
                <td>
                  <v-textarea
                    :rules="[$rules.required]"
                    solo
                    hide-details=""
                    :placeholder="$t('messageBody')"
                    v-model="message.body"
                  ></v-textarea>
                </td>
              </tr>
              <tr>
                <td>{{ $t("messageType") }}:</td>
                <td>
                  <v-radio-group v-model="message.messageType">
                    <v-radio :label="$t('normalMessage')" :value="1"></v-radio>
                    <v-radio :label="$t('systemMessage')" :value="2"></v-radio>
                  </v-radio-group>
                </td>
              </tr>
              <tr>
                <td>{{ $t("sectionType") }}:</td>
                <td>
                  <v-select
                    hide-details
                    v-model="sectionType"
                    :items="sectionTypes"
                    :label="$t('sectionType')"
                    item-text="Name"
                    item-value="Code"
                    return-object
                    dense
                    solo
                    v-on:change="changeSectionType"
                    class="my-auto py-0"
                  ></v-select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="!form" @click="sendMessage">{{
          $t("send")
        }}</v-btn>
      </v-card-actions>
      <personel-reciever class="mt-2" :personels="personels" />
    </box>
  </div>
</template>

<script>
import personelReciever from "../../components/messages/personelReciever.vue";
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
export default {
  components: { personelReciever },
  data() {
    return {
      form: false,
      message: {
        messageType: 1,
        title: "",
        body: "",
      },
      sectionType: "",
      sectionTypes: [],
      personels: [],
    };
  },
  mounted() {
    this.getSections();
    this.pageLoad();
  },
  methods: {
    pageLoad() {
      var promises = [];
      var dsManagers = [];
      var dsPersonels = [];

      var sectionid = "";
      promises.push(
        this.$store.dispatch("sections/GetWebSectionsAdmins", { sectionid })
      );

      var permissionNumber = 60;
      promises.push(
        this.$store.dispatch("GetAccessPersonList", { permissionNumber })
      );

      Promise.all(promises).then((result) => {
        //console.log(result);
        var dsManagersResult = result[0];
        if (dsManagersResult.type == ResultType.success) {
          dsManagers = dsManagersResult.data.Table;
        }
        console.log(dsManagers);

        var dsPersonelsResult = result[1];
        if (dsPersonelsResult.type == ResultType.success) {
          dsPersonels = dsPersonelsResult.data;
        }
        console.log(dsPersonels);

        //var pernos = ["1000", "1006"];
        var pernos = [];
        this.$store
          .dispatch("getPersonelsSection", { pernos })
          .then((getPersonelsSectionResult) => {
            console.log(getPersonelsSectionResult);
          });
      });
    },
    getSections() {
      if (EosUtils.isWebKartAdmin()) {
        this.getAllSection();
      } else {
        this.getSectionWithPermissionNumber();
      }
    },
    getAllSection() {
      this.sectionTypes.push({ Name: "", Code: "" });
      if (!EosUtils.isWebKartAdmin()) {
        this.sectionTypes.push({
          Name: "مدیر وب کارت",
          Code: "eosWebKartAdmin",
        });
      }

      this.$store.dispatch("sections/GetAllSections").then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          this.GetSectionPersons();
        } else {
          this.sectionTypes.splice(0);
        }
      });
    },
    async getSectionWithPermissionNumber() {
      var params = new URLSearchParams();
      params.append("accessTo", 60);

      this.$store
        .dispatch("sections/GetSectionsList", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type == ResultType.success) {
            this.sectionTypes.push(...result.data);
            if (this.sectionTypes.length > 0) {
              this.sectionType = this.sectionTypes[0];
            }

            this.GetSectionPersons();
          }
        });
    },
    changeSectionType() {
      this.GetSectionPersons();
    },
    GetSectionPersons() {
      var params = {
        sectionCode: this.sectionType?.Code?.toString().trim(),
      };
      this.$store.dispatch("GetSectionPersons", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.personels = result.data.Table1;
        }
      });
    },
    sendMessage() {
      var selectedPersonels = this.personels.filter(
        (personel) => personel.selected === true
      );
      //console.log(selectedPersonels);
      if (!(selectedPersonels.length > 0)) {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg:"حداقل یک پرسنل باید انتخاب شود.",
        });
      }

      selectedPersonels.forEach((selectedPersonel) => {
        //console.log(selectedPersonel);

        var params = new URLSearchParams();
        params.append("toid", selectedPersonel.PERNO.replaceAll(" ", ""));
        params.append("subject", this.message.title);
        params.append("message", this.message.body);
        params.append("isForced", this.message.messageType == 2);

        this.$store.dispatch("NewMessage", { params }).then((result) => {
          console.log(result);
          if (result.type === ResultType.success) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg:
                " پیام به " +
                selectedPersonel.PersonName +
                " با موفقیت ارسال شد ",
            });
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg:
                " ارسال پیام به " +
                selectedPersonel.PersonName +
                " با خطا مواجه شد ",
            });
          }
        });
      });
    },
  },
};
</script>

<style>
</style>